export const
    Call = "Call",
    ContractVisit = "ContractVisit",
    ContractVisitSegment = "ContractVisitSegment",
    ContractVisitLine = "ContractVisitLine",
    ContractVisitAppointment = "ContractVisitAppointment",
    Order = "Order",
    OrderSegment = "OrderSegment",
    OrderLine = "OrderLine",
    Appointment = "Appointment",
    OrderTemplate = "OrderTemplate",
    OrderTemplateSegment = "OrderTemplateSegment",
    OrderTemplateLine = "OrderTemplateLine",
    OrderTemplateAppointment = "OrderTemplateAppointment",
    Payment = "Payment",
    Quote = "Quote",
    QuoteSegment = "QuoteSegment",
    QuoteLine = "QuoteLine",
    Segment = "Segment",
    Line = "Line"
;
